import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';

import TaskDashboard from '../TaskDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function TaskPage() {
    const dispatch = useDispatch();
    const { TaskList} = useSelector((state)=>state.manufaslice)
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < TaskDashboard />
    )

}